import { endpoints } from '@/services/base';
import { IPlanDetail, IPlanFormData } from '@/types/plan';

export const mapPlanDetailToFormData = (planDetail: IPlanDetail): IPlanFormData => {
  const formData: IPlanFormData = {
    name: planDetail.name,
    price: planDetail.price,
    description: planDetail.description,
    htmlFile: undefined,
    cssFile: undefined,
    jsFile: undefined,
    imageZipFile: undefined,
    images: [],
  };

  const activeAttachments = planDetail.planAttachments.filter(
    (planAttachment) => !planAttachment.isArchived
  );

  activeAttachments.forEach((planAttachment) => {
    const { attachment } = planAttachment;
    const mimeType = attachment.mimeType.toLowerCase();
    const fileName = attachment.fileName.toLowerCase();

    if (mimeType.includes('html') || fileName.endsWith('.html')) {
      formData.htmlFile = createFileFromAttachment(attachment);
    } else if (mimeType.includes('css') || fileName.endsWith('.css')) {
      formData.cssFile = createFileFromAttachment(attachment);
    } else if (
      mimeType.includes('javascript') ||
      mimeType.includes('js') ||
      fileName.endsWith('.js')
    ) {
      formData.jsFile = createFileFromAttachment(attachment);
    } else if (mimeType.includes('zip') || fileName.endsWith('.zip')) {
      formData.imageZipFile = createFileFromAttachment(attachment);
    } else if (mimeType.includes('image')) {
      formData.images = [...(formData.images || []), attachment];
    }
  });

  return formData;
};

const createFileFromAttachment = (attachment: any): File | undefined => {
  try {
    const blob = new Blob([''], { type: attachment.mimeType });
    return new File([blob], attachment.fileName, { type: attachment.mimeType });
  } catch {
    return undefined;
  }
};

export const createFileUrl = (attachmentId: string): string => {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return `${apiUrl}${endpoints.attachments.default}/${attachmentId}/download`;
};

export const downloadFileAsBlob = async (
  attachmentId: string,
  fileName: string,
  mimeType: string
): Promise<File> => {
  const fileUrl = createFileUrl(attachmentId);

  try {
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    return new File([blob], fileName, { type: mimeType });
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};

export const mapPlanAttachmentsToFileUrls = (planDetail: IPlanDetail) => {
  const fileUrls: Record<string, { url: string; fileName: string }> = {};

  const activeAttachments = planDetail.planAttachments.filter(
    (planAttachment) => !planAttachment.isArchived
  );

  activeAttachments.forEach((planAttachment) => {
    const { attachment } = planAttachment;
    const mimeType = attachment.mimeType.toLowerCase();
    const fileName = attachment.fileName.toLowerCase();

    if (mimeType.includes('html') || fileName.endsWith('.html')) {
      fileUrls.htmlFile = {
        url: createFileUrl(attachment.id),
        fileName: attachment.originName,
      };
    } else if (mimeType.includes('css') || fileName.endsWith('.css')) {
      fileUrls.cssFile = {
        url: createFileUrl(attachment.id),
        fileName: attachment.originName,
      };
    } else if (
      mimeType.includes('javascript') ||
      mimeType.includes('js') ||
      fileName.endsWith('.js')
    ) {
      fileUrls.jsFile = {
        url: createFileUrl(attachment.id),
        fileName: attachment.originName,
      };
    } else if (mimeType.includes('zip') || fileName.endsWith('.zip')) {
      fileUrls.imageZipFile = {
        url: createFileUrl(attachment.id),
        fileName: attachment.originName,
      };
    }
  });

  return fileUrls;
};
